(() => {
  angular
    .module('gm.common.services')
    .factory('GmyApiWatcher', GmyApiWatcher);

  function GmyApiWatcher(
    $location,
    $route,
    gmyAcl,
    gmApi,
    GmyToken,
    GmyRouter
  ) {
    'ngInject';

    const NOT_FATAL_401_ERRORS = [
      'error.expecting.twoFA.code',
      'missing.captcha',
    ];

    const NOT_FATAL_403_ERRORS = [
      'request.not.allowed',
    ];

    return {
      watchApiErrors,
    };

    function watchApiErrors() {
      if ($location.path().length > 0) {
        gmApi.onError((error) => {
          // hack to support different permissions structure
          let permissions = [];
          const route = $route.current.$$route;
          if ('permissions' in route) {
            permissions = route.permissions;
          } else if ('data' in route && 'permissions' in route.data) {
            permissions = route.data.permissions;
          }

          if (permissions.indexOf(gmyAcl.PERMISSIONS.ANONYMOUS) === -1) {
            if (!GmyRouter.isSignIn()) {
              if (error.status === 403 && NOT_FATAL_403_ERRORS.indexOf(error.data.message) === -1) {
                GmyToken.removeToken();
                GmyRouter.goToSignIn();
              }

              if (error.status === 401 && NOT_FATAL_401_ERRORS.indexOf(error.data.message) === -1) {
                GmyToken.removeToken();
                GmyRouter.goToSignIn();
              }
            }
          }

          if (error.status === 423) {
            GmyToken.removeToken();
            GmyRouter.goToSignIn('suspended');
          }
        });
      }
    }
  }
})();
